import React, { useEffect, useState } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css'
import { Table, Empty } from 'antd'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import PropTypes from 'prop-types'
import { getFinalReport } from 'src/Services/StudentServices/CareerPathAssessmentService'
import { getStudentStatus } from 'src/Services/StudentServices/StudentAssessmentStatusService'
import { behaviorScoreLabel } from 'src/Common/studentAssessmentEnums'
import PersonalityResult from 'src/Pages/StudentPages/Assessments/PersonalityResult'
import CareerPathResultView from 'src/Pages/StudentPages/Assessments/CareerPathResultView'
import 'src/Pages/LibraryPages/librarypages.scss'

const ReportIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M14 3v4a1 1 0 0 0 1 1h4" />
    <path d="M17 21H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7l5 5v11a2 2 0 0 1-2 2Z" />
    <path d="M9 17v-4M12 17v-2M15 17v-6" />
  </svg>
)

const DownloadIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M12 3v12" />
    <path d="M7 10l5 5 5-5" />
    <path d="M5 21h14" />
  </svg>
)

const BackIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M15 18l-6-6 6-6" />
  </svg>
)

const UserIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ width: 16, height: 16 }}
    aria-hidden="true"
  >
    <circle cx="12" cy="8" r="4" />
    <path d="M4 21a8 8 0 0 1 16 0" />
  </svg>
)

const ChartIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ width: 16, height: 16 }}
    aria-hidden="true"
  >
    <path d="M4 4v16h16" />
    <path d="M8 16v-4M12 16v-7M16 16v-3" />
  </svg>
)

const PersonalityIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ width: 16, height: 16 }}
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="9" />
    <circle cx="12" cy="12" r="5" />
    <circle cx="12" cy="12" r="1.5" />
  </svg>
)

const SchoolIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ width: 16, height: 16 }}
    aria-hidden="true"
  >
    <path d="M12 3 2 8l10 5 10-5-10-5Z" />
    <path d="M6 10v5c0 1 2.7 3 6 3s6-2 6-3v-5" />
  </svg>
)

const CompassIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ width: 16, height: 16 }}
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="9" />
    <path d="M15.5 8.5 13 13l-4.5 2.5L11 11l4.5-2.5Z" />
  </svg>
)

const NoteIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ width: 16, height: 16 }}
    aria-hidden="true"
  >
    <path d="M4 4h13l3 3v13a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1z" />
    <path d="M8 8h6M8 12h8M8 16h5" />
  </svg>
)

const HeaderBlock = () => (
  <div className="lpg__head">
    <div className="lpg__head-main">
      <span className="lpg__head-ic">
        <ReportIcon />
      </span>
      <div>
        <h1 className="lpg__title">Final Student Report</h1>
        <p className="lpg__sub">Complete career path assessment and recommendations.</p>
      </div>
    </div>
  </div>
)

const sectionTitleStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  margin: '0 0 14px',
  fontFamily: "'Bricolage Grotesque', sans-serif",
  fontWeight: 700,
  fontSize: '1.05rem',
  letterSpacing: '-0.01em',
  color: '#16233f',
}
const sectionIcStyle = {
  display: 'inline-grid',
  placeItems: 'center',
  width: '30px',
  height: '30px',
  borderRadius: '9px',
  color: '#fff',
  background: 'linear-gradient(135deg, #0c2350 0%, #1d4ed8 100%)',
  flex: 'none',
}
const infoListStyle = { listStyle: 'none', margin: 0, padding: 0, display: 'grid', gap: '8px' }
const rowStyle = {
  display: 'flex',
  gap: '8px',
  fontSize: '0.9rem',
  color: '#3a4763',
  padding: '9px 12px',
  background: '#fbfcfe',
  border: '1px solid #e6ebf3',
  borderRadius: '10px',
}
const statLineStyle = { margin: '6px 0', fontSize: '0.9rem', color: '#3a4763' }
const reportBodyStyle = { display: 'grid', gap: '18px' }
const softNoteStyle = { margin: 0, fontSize: '0.9rem', color: '#64748b' }

const SectionTitle = ({ icon, children }) => (
  <h2 style={sectionTitleStyle}>
    <span style={sectionIcStyle}>{icon}</span>
    {children}
  </h2>
)
SectionTitle.propTypes = { icon: PropTypes.node, children: PropTypes.node }

const rankText = (value) => (value === null || value === undefined ? 'N/A' : value)

const FinalStudentReport = ({ careerPathReportId, studentId, Back }) => {
  const [studentData, setStudentData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [dataLoading, setDataLoading] = useState(true)
  const [notReady, setNotReady] = useState(false)
  const [loadError, setLoadError] = useState(false)
  const role = localStorage.getItem('role')
  const roles = JSON.parse(localStorage.getItem('roles') || '[]')

  useEffect(() => {
    // Mounted as a bare route in the counselor/parent/student shells with no props: skip the
    // fetch rather than calling the API with studentId=undefined&careerPathReportId=undefined.
    if (!studentId) {
      setDataLoading(false)
      return undefined
    }

    let active = true
    const fetchStudentData = async () => {
      setDataLoading(true)
      setNotReady(false)
      setLoadError(false)
      try {
        // The card picker passes only studentId; resolve the latest career path report id from
        // the student's assessment status when it is not supplied directly (the mentor view
        // passes it as a prop). getFinalReport then routes through the shared apiClient (auth
        // interceptor attaches the token) and picks the parent-scoped route for a Parent.
        let reportId = careerPathReportId
        if (!reportId) {
          const s = await getStudentStatus(studentId)
          reportId = s?.latestCareerPathReportId
        }
        if (!reportId) {
          if (active) setNotReady(true)
          return
        }
        const data = await getFinalReport(studentId, reportId)
        if (!active) return
        setStudentData(data)
        if (typeof window.updateBadgeCount === 'function') {
          window.updateBadgeCount()
        }
      } catch (error) {
        if (!active) return
        // The report is only available once every review is approved. The backend answers a
        // not-ready report with 400 + code FINAL_REPORT_NOT_READY; show a soft info state.
        const status = error?.response?.status
        const body = error?.response?.rawData || error?.response?.data
        const code = body && typeof body === 'object' ? body.code || body.errorCode : undefined
        const messageText =
          typeof body === 'string' ? body : (body && (body.message || body.title)) || ''
        const isNotReady =
          status === 400 &&
          (String(code) === 'FINAL_REPORT_NOT_READY' || /not available until/i.test(messageText))
        if (isNotReady) {
          setNotReady(true)
        } else {
          setLoadError(true)
        }
      } finally {
        if (active) setDataLoading(false)
      }
    }

    fetchStudentData()
    return () => {
      active = false
    }
  }, [studentId, careerPathReportId])

  const handleDownloadPDF = () => {
    setLoading(true)
    const content = document.getElementById('student-report')
    html2canvas(content).then((canvas) => {
      const imgData = canvas.toDataURL('image/png')
      const pdf = new jsPDF('p', 'mm', 'a4')
      const imgWidth = 190
      const pageHeight = 297
      const imgHeight = (canvas.height * imgWidth) / canvas.width
      let heightLeft = imgHeight
      let position = 10

      pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight)
      heightLeft -= pageHeight

      while (heightLeft > 0) {
        position = heightLeft - imgHeight
        pdf.addPage()
        pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight)
        heightLeft -= pageHeight
      }

      pdf.save('FinalStudentReport.pdf')
      setLoading(false)
    })
  }

  if (dataLoading) {
    return (
      <div className="lpg">
        <HeaderBlock />
        <div className="lpg__state">
          <div className="lpg__spin" />
          Loading...
        </div>
      </div>
    )
  }

  if (notReady) {
    return (
      <div className="lpg">
        <div className="lpg__head">
          <div className="lpg__head-main">
            <span className="lpg__head-ic">
              <ReportIcon />
            </span>
            <div>
              <h1 className="lpg__title">Final Student Report</h1>
              <p className="lpg__sub">Complete career path assessment and recommendations.</p>
            </div>
          </div>
          <div className="lpg__actions">
            <button className="lpg__back" type="button" onClick={Back}>
              <BackIcon /> Back
            </button>
          </div>
        </div>
        <div className="lpg__panel-box">
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="The final report will be available once Personality, Career Path and University recommendations are all approved."
          />
        </div>
      </div>
    )
  }

  if (loadError || !studentData) {
    return (
      <div className="lpg">
        <div className="lpg__head">
          <div className="lpg__head-main">
            <span className="lpg__head-ic">
              <ReportIcon />
            </span>
            <div>
              <h1 className="lpg__title">Final Student Report</h1>
              <p className="lpg__sub">Complete career path assessment and recommendations.</p>
            </div>
          </div>
          <div className="lpg__actions">
            <button className="lpg__back" type="button" onClick={Back}>
              <BackIcon /> Back
            </button>
          </div>
        </div>
        <div className="lpg__panel-box">
          <Empty
            description={
              loadError ? 'We could not load this report. Please try again.' : 'No Data Available'
            }
          />
        </div>
      </div>
    )
  }

  const behaviorReport = studentData.behaviorReport
  const personalityResult = studentData.personalityAssessment
    ? studentData.personalityAssessment.result
    : null
  const careerRecommendations = studentData.careerPath?.careerRecommendations || []
  const careerPathAiResult = studentData.careerPath?.aiResult
  const recommendedUniversities =
    studentData.universityRecommendation?.recommendedUniversities || []
  const notes = Array.isArray(studentData.notes) ? studentData.notes : []
  const canDownload = !((role === 'Parent' && roles.includes('Student')) || role === 'Student')

  const behaviorGoalColumns = [
    { title: 'Goal', dataIndex: 'goalDescription', key: 'goalDescription' },
    {
      title: 'Score (1-4)',
      dataIndex: 'counselorAssessment',
      key: 'counselorAssessment',
      render: (value) => {
        if (value === null || value === undefined) return 'N/A'
        const label = behaviorScoreLabel(value)
        return label ? `${value} (${label})` : `${value}`
      },
    },
  ]

  const careerColumns = [
    { title: 'Career', dataIndex: 'name', key: 'name' },
    { title: 'Reason', dataIndex: 'reason', key: 'reason' },
    { title: 'Rank', dataIndex: 'rank', key: 'rank', render: rankText },
  ]

  const universityColumns = [
    { title: 'University', dataIndex: 'name', key: 'name' },
    { title: 'Reason', dataIndex: 'recommendationReason', key: 'recommendationReason' },
    { title: 'State', dataIndex: 'state', key: 'state' },
    { title: 'Type', dataIndex: 'type', key: 'type' },
    { title: 'Rank', dataIndex: 'rank', key: 'rank', render: rankText },
    { title: 'Probability With SAT', dataIndex: 'probabilityWithSAT', key: 'probabilityWithSAT' },
    { title: 'Probability Without SAT', dataIndex: 'probabilityNoSAT', key: 'probabilityNoSAT' },
  ]

  const subtitle = studentData.studentName
    ? `Career path assessment and recommendations for ${studentData.studentName}.`
    : 'Complete career path assessment and recommendations.'

  return (
    <div className="lpg">
      <div className="lpg__head">
        <div className="lpg__head-main">
          <span className="lpg__head-ic">
            <ReportIcon />
          </span>
          <div>
            <h1 className="lpg__title">Final Student Report</h1>
            <p className="lpg__sub">{subtitle}</p>
          </div>
        </div>
        <div className="lpg__actions">
          {canDownload && (
            <button
              className="lpg__btn-primary"
              type="button"
              onClick={handleDownloadPDF}
              disabled={loading}
            >
              <DownloadIcon />
              {loading ? 'Please wait...' : 'Download PDF'}
            </button>
          )}
          <button className="lpg__back" type="button" onClick={Back}>
            <BackIcon /> Back
          </button>
        </div>
      </div>

      <div id="student-report" style={reportBodyStyle}>
        {/* Overview */}
        <div className="lpg__panel-box">
          <SectionTitle icon={<UserIcon />}>Student Information</SectionTitle>
          <ul style={infoListStyle}>
            <li style={rowStyle}>
              <strong>Student Name:</strong> {studentData.studentName || 'N/A'}
            </li>
            {studentData.counselorName ? (
              <li style={rowStyle}>
                <strong>Counselor:</strong> {studentData.counselorName}
              </li>
            ) : null}
            {studentData.parentName ? (
              <li style={rowStyle}>
                <strong>Parent:</strong> {studentData.parentName}
              </li>
            ) : null}
          </ul>
        </div>

        {/* Behavior summary */}
        <div className="lpg__panel-box">
          <SectionTitle icon={<ChartIcon />}>Behavior Agreement Assessment</SectionTitle>
          {behaviorReport ? (
            <>
              <p style={statLineStyle}>
                <strong>Sessions Completed:</strong> {behaviorReport.sessionsCompleted}
              </p>
              <p style={statLineStyle}>
                <strong>Overall Performance Score (1-4):</strong>{' '}
                {behaviorReport.overallPerformanceScore}
              </p>
              <p style={statLineStyle}>
                <strong>Key Strength:</strong> {behaviorReport.keyStrength || 'N/A'}
              </p>
              <p style={statLineStyle}>
                <strong>Areas for Improvement:</strong>{' '}
                {behaviorReport.areasForImprovement || 'N/A'}
              </p>
              <Table
                className="table-responsive"
                dataSource={behaviorReport.behaviorGoals || []}
                columns={behaviorGoalColumns}
                rowKey={(record, index) => `${record.goalDescription || 'goal'}-${index}`}
                pagination={false}
                bordered
              />
            </>
          ) : (
            <p style={softNoteStyle}>No behavior agreement yet.</p>
          )}
        </div>

        {/* Personality (DISC) */}
        <div className="lpg__panel-box">
          <SectionTitle icon={<PersonalityIcon />}>Personality (DISC)</SectionTitle>
          <PersonalityResult result={personalityResult} />
        </div>

        {/* Career Path */}
        <div className="lpg__panel-box">
          <SectionTitle icon={<CompassIcon />}>Career Path Assessment</SectionTitle>
          {careerPathAiResult ? (
            <CareerPathResultView result={careerPathAiResult} careers={[]} />
          ) : (
            <p style={softNoteStyle}>No AI career path insights are available.</p>
          )}
          <h3 style={{ margin: '20px 0 12px', fontSize: '1rem', color: '#16233f' }}>
            Final career recommendations
          </h3>
          {careerRecommendations.length ? (
            <Table
              className="table-responsive"
              dataSource={careerRecommendations}
              columns={careerColumns}
              rowKey={(record, index) =>
                record.careerId != null ? record.careerId : `career-${index}`
              }
              pagination={{ pageSize: 30, hideOnSinglePage: true }}
              bordered
            />
          ) : (
            <p style={softNoteStyle}>No career recommendations yet.</p>
          )}
        </div>

        {/* University recommendations */}
        <div className="lpg__panel-box">
          <SectionTitle icon={<SchoolIcon />}>University Recommendations</SectionTitle>
          {recommendedUniversities.length ? (
            <Table
              className="table-responsive"
              dataSource={recommendedUniversities}
              columns={universityColumns}
              rowKey={(record, index) => `${record.name || 'university'}-${index}`}
              pagination={{ pageSize: 30, hideOnSinglePage: true }}
              bordered
            />
          ) : (
            <p style={softNoteStyle}>No university recommendations yet.</p>
          )}
        </div>

        {/* Notes */}
        {notes.length > 0 && (
          <div className="lpg__panel-box">
            <SectionTitle icon={<NoteIcon />}>Notes</SectionTitle>
            <ul style={infoListStyle}>
              {notes.map((note, index) => (
                <li key={index} style={rowStyle}>
                  {note}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  )
}

FinalStudentReport.propTypes = {
  // Optional: also mounted as a bare route (no props) in the counselor/parent/student shells,
  // where it renders empty and skips the fetch until real ids arrive via navigation.
  studentId: PropTypes.number,
  careerPathReportId: PropTypes.number,
  Back: PropTypes.func,
}

export default FinalStudentReport
